import { supabase } from "../lib/supabase";

export async function getExpensesForProject(projectId) {
  const { data, error } = await supabase
    .from("project_expenses")
    .select("*")
    .eq("project_id", projectId)
    .order("expense_date", { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function createExpense(projectId, payload) {
  const { data: { user }, error: userError } = await supabase.auth.getUser();
  if (userError) throw userError;
  if (!user) throw new Error("Not logged in");

  const { data, error } = await supabase
    .from("project_expenses")
    .insert([{
      user_id: user.id,
      project_id: projectId,
      vendor: payload.vendor || null,
      description: payload.description || null,
      amount: Number(payload.amount || 0),
      expense_date: payload.expense_date || null,
    }])
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deleteExpense(expenseId) {
  const { error } = await supabase
    .from("project_expenses")
    .delete()
    .eq("id", expenseId);

  if (error) throw error;
}
